import React, { useState } from 'react';

import type { GradeScore } from '../../../../types/frapi-types.js';

import Grade from './Grade.js';

type GradesProps = {
  grades: {
    name: string;
    value: GradeScore;
  }[];
};

const Grades: React.FC<GradesProps> = ({ grades }) => {
  const [open, setOpen] = useState(false);

  const toggleGradesVisibility = () => {
    setOpen(!open);
  };

  const handleKeyPress = (event: { key: string }) => {
    if (event.key === 'Enter' || event.key === ' ') {
      toggleGradesVisibility;
    }
  };

  return (
    <div
      className="grades"
      onClick={toggleGradesVisibility}
      onKeyDown={handleKeyPress}
      role="button"
      tabIndex={0}
    >
      <div className="toggle-grades">
        <p className="title">Vår vurdering</p>
        <div className={`dropdown-button ${open ? 'open' : 'closed'}`} />
      </div>
      {open && (
        <div className="sub-grades">
          {grades
            .filter((grade) => grade.value)
            .map((grade, index) => (
              <Grade
                key={`grade-${index}`}
                name={grade.name}
                value={grade.value}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export default Grades;
